(function () {
  function initCopyButtons(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-miix-copy]').forEach(function (button) {
      if (button.dataset.miixCopyBound === 'true') return;
      button.dataset.miixCopyBound = 'true';

      button.addEventListener('click', function () {
        var value = button.getAttribute('data-miix-copy') || '';
        var original = button.getAttribute('data-label-default') || button.textContent.trim();
        var success = button.getAttribute('data-label-success') || 'Copiado';

        function showCopied() {
          button.classList.add('is-copied');
          button.textContent = success;
          window.setTimeout(function () {
            button.classList.remove('is-copied');
            button.textContent = original;
          }, 1800);
        }

        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(value).then(showCopied).catch(function () {
            fallbackCopy(value, showCopied);
          });
        } else {
          fallbackCopy(value, showCopied);
        }
      });
    });
  }

  function fallbackCopy(value, onSuccess) {
    var input = document.createElement('textarea');
    input.value = value;
    input.setAttribute('readonly', '');
    input.style.position = 'absolute';
    input.style.left = '-9999px';
    document.body.appendChild(input);
    input.select();
    try {
      document.execCommand('copy');
      onSuccess();
    } catch (e) {}
    document.body.removeChild(input);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initCopyButtons(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initCopyButtons(event.target);
  });
})();
